"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _HBFileThumbnail = require("./HBFileThumbnail.styles");
var _getFileIcon = require("../HBFileThumbnail/utils/getFileIcon");
var _HBFileThumbnailActions = _interopRequireDefault(require("../HBFileThumbnail/HBFileThumbnailActions"));
var _HBFilePreview = _interopRequireDefault(require("../HBFilePreview/HBFilePreview"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBFileThumbnail = function HBFileThumbnail(_ref) {
  var file = _ref.file,
    isDeletable = _ref.isDeletable,
    onDeleteFile = _ref.onDeleteFile,
    onDownloadFile = _ref.onDownloadFile,
    isSelectable = _ref.isSelectable,
    isSelected = _ref.isSelected,
    onClickThumbnail = _ref.onClickThumbnail,
    selectedPosition = _ref.selectedPosition,
    deleteTooltipText = _ref.deleteTooltipText;
  var fileIcon = (0, _getFileIcon.getFileIcon)(file);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isPreviewShown = _useState2[0],
    setIsPreviewShown = _useState2[1];
  var _onClick = function _onClick() {
    if (isSelectable) {
      onClickThumbnail === null || onClickThumbnail === void 0 || onClickThumbnail(file);
    } else {
      setIsPreviewShown(true);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_HBFileThumbnail.ThumbnailWrapper, {
    onClick: _onClick,
    isUploading: file.isUploading,
    isSelected: isSelected,
    isSelectable: isSelectable
  }, isSelectable && /*#__PURE__*/_react["default"].createElement(_HBFileThumbnail.SelectedFileBox, {
    "aria-hidden": "true",
    visible: isSelected
  }, selectedPosition), /*#__PURE__*/_react["default"].createElement(_HBFileThumbnail.ThumbnailImageContainer, null, /*#__PURE__*/_react["default"].createElement(_HBFileThumbnail.ThumbnailImage, {
    src: fileIcon
  })), /*#__PURE__*/_react["default"].createElement(_HBFileThumbnail.ThumbnailBody, null, /*#__PURE__*/_react["default"].createElement(_HBFileThumbnail.ThumbnailFileName, {
    type: "emphasis12",
    color: "textPrimary"
  }, file.name)), !isSelectable && /*#__PURE__*/_react["default"].createElement(_HBFileThumbnailActions["default"], {
    onDeleteFile: onDeleteFile,
    onDownloadFile: onDownloadFile,
    isDeletable: isDeletable,
    file: file,
    deleteTooltipText: deleteTooltipText
  }), isPreviewShown && /*#__PURE__*/_react["default"].createElement(_HBFilePreview["default"], {
    fileName: file.name,
    fileUrl: file.url,
    fileType: "file",
    onClose: function onClose() {
      return setIsPreviewShown(false);
    },
    onDownload: function onDownload() {
      return onDownloadFile(file);
    },
    onDelete: function onDelete() {
      return onDeleteFile(file);
    }
  }));
};
var _default = exports["default"] = HBFileThumbnail;
//# sourceMappingURL=HBFileThumbnail.js.map